import styled from 'styled-components'
import { Plus } from '@styled-icons/boxicons-regular/Plus'
import { Minus } from '@styled-icons/boxicons-regular/Minus'
import { BaseButton } from '../../../styles/baseStyledComponents'

export const ProductTitle = styled.h3`
  margin-bottom: 0;
`

export const ProductDetails = styled.ul``

export const Divider = styled.div`
  background-color: #78909c;
  width: 70%;
  height: 2px;
  margin: 20px auto 20px auto;
`

export const ProductWrapper = styled.div`
  margin-top: 2rem;  
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  cursor: pointer;
`

export const LeftHeader = styled.div`
  display: flex;
  align-items: center;
`

export const PlusIcon = styled(Plus)`
  width: 40px;
`

export const MinusIcon = styled(Minus)`
  width: 40px;
`

export const Button = styled(BaseButton)`
  padding: 10px 30px;
`
